import { ratesByState } from '@/app/(marketplace)/quote-builder/electricity-rates/rates';

import { historicalRatesByState } from '../data/historicalRates';

import { todayStepFraction } from './projectMonthlyBills';
import { BillPoint, ProjectionInput } from './types';

type DeepHistoryInput = Omit<ProjectionInput, 'homeSqft'>;

// 2005–2020 back-cast for the chart's "show the past" expansion: the entered
// bill priced at each year's actual EIA state-average rate (constant usage).
// The entered bill is TODAY (current year), so the latest EIA year backs out
// this year's step first — same anchoring as projectMonthlyBills, so the two
// series join seamlessly at 2020→2021.
export const backcastDeepHistory = ({
  monthlyBillUsd,
  monthlyKwh,
  stateCode,
}: DeepHistoryInput): BillPoint[] | undefined => {
  const anchorRates = ratesByState[stateCode]?.rates;
  const rates = historicalRatesByState[stateCode];
  if (!anchorRates?.length || !rates?.length || (!monthlyBillUsd && !monthlyKwh)) {
    return undefined;
  }

  const latest = anchorRates[anchorRates.length - 1];
  const todayStep = todayStepFraction(stateCode).fraction;
  // Entered usage is today's usage too, so it is priced at this year's rate
  const anchorBillUsd = monthlyBillUsd ?? (monthlyKwh ?? 0) * (latest.rate / 100) * (1 + todayStep);
  const latestEiaBillUsd = anchorBillUsd / (1 + todayStep);

  return rates.map(({ rate, year }, i) => ({
    isProjected: false,
    monthlyBillUsd: latestEiaBillUsd * (rate / latest.rate),
    year,
    yoyFraction: i === 0 ? null : rate / rates[i - 1].rate - 1,
  }));
};
